import { FC, useEffect, useRef } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Model
import { RootState } from 'app/store';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { AppUiNotificationsActions } from 'app/store/AppUINotifications/AppUINotifications.slice';
// Selectors
import { selectPushAlert } from 'app/store/AppUINotifications/AppUINotifications.selectors';
// Mui
import { Alert, Typography } from '@mui/material';
// Components
import { Button } from './Mui';

type Props = {
  documentId?: number;
  type: 'labels';
  applyFunc?: () => void;
}

const DocumentPushAlert:FC<Props> = ({
  // Props
  documentId, type, applyFunc
}) => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const alert = useAppSelector((state:RootState) => selectPushAlert(state, {
    category: 'document',
    type
  }));

  const lastAlertRef = useRef(alert);

  useEffect(() => {
    lastAlertRef.current = alert;
  }, [alert]);

  useEffect(() => {
    return () => {
      if ( lastAlertRef.current ) dispatch(AppUiNotificationsActions.removePushAlert({
        category: 'document',
        type
      }));
    }
    // eslint-disable-next-line
  }, []);

  const handleClick = () => {
    dispatch(AppUiNotificationsActions.removePushAlert({
      category: 'document',
      type
    }));
  }

  const handleApply = () => {
    if ( applyFunc === undefined ) return;
      applyFunc();
      handleClick();
  }

  if ( !alert || documentId !== alert.documentId ) return null;
  return (
    <Alert
      sx={{ mb: 4, alignItems: 'center' }}
      color="warning"
      onClose={handleClick}
      action={applyFunc ? (
        <Button
          name="apply-changes"
          size="small"
          variant="contained"
          onClick={handleApply}
        >{t('buttons.applyChanges')}</Button>
      ) : undefined}
    >
      {alert.message}
      <Typography component="span" sx={{ display: 'block', fontSize: '11px' }}>
        {t('form.helperText.pushAlertLabelsHint')}
      </Typography>
    </Alert>
  )
}

export default DocumentPushAlert;
